import { AbstractBomValue } from "./abstractBomValue";

export class ConfBomValue extends AbstractBomValue {
}